/* eslint-disable no-use-before-define */
import "./trade-history.css"
import React from 'react'
import { proxyContext, ProxyContext, hideModal, Status, Loading, } from '../twd'
import { controller, Errors } from './controller'
import { Header } from "./header"
import { Filter } from "./filter"
import { LastTrade } from "./last-trade"
import { SummaryTable } from "./summary-table"
import { PriceHistory } from "./price-history"
import { YieldHistory } from "./yield-history"
import { ErrorMessage } from './error-message'
import { Disclaimer } from "./disclaimer"

export const Main = ({cusip:cusip_}) => {
    const cusip = Array.isArray(cusip_) ? cusip_[0] : cusip_
    const [status, setStatus] = React.useState(Status.LOADING)
    const [reloadStatus, setReloadStatus] = React.useState(Status.NULL)
    const [filterByDate, setFilterByDate] = React.useState(30)
    const [showDataAs, setShowDataAs] = React.useState("summary-table")
    const [error, setError] = React.useState(Errors.NO_TRADE_DATA)
    const [isDisclaimer, setIsDisclaimer] = React.useState(false)

    const proxy = proxyContext(controller, {
        cusip, 
        status, setStatus, 
        reloadStatus, setReloadStatus,
        filterByDate, setFilterByDate, 
        showDataAs, setShowDataAs,
        error, setError,
        isDisclaimer, setIsDisclaimer,
    }, "trade-history")

    React.useEffect(() => { 
        proxy.refresh() 
    }, [cusip, filterByDate])

    return <React.Fragment>
    <div
        date-name="trade-history"
        className="modal-dialog modal-lg trade-history trade-history-dialog">
        {reloadStatus === Status.LOADING && (
            <div className="trade-history-mask" aria-hidden="true">
                <Loading status={reloadStatus} />
            </div>
        )}
    <div className="modal-content">

        <div className="modal-header">
            <button
                date-name="trade-history-close"
                className="close"
                aria-label="close"
                type="button"
                onClick={() => {
                    ProxyContext.destroy('trade-history')
                    hideModal()
                }}>
            <i className="material-icons" aria-hidden="true">close</i>
            </button>

            <h2 className="modal-title large-header text-center">
                Trade history details
            </h2>
        </div>

        <div className="modal-body" style={{width:'100%'}}>
        <Loading status={status}>
            <div className="container">
            {isDisclaimer && <Disclaimer></Disclaimer>}
            {!isDisclaimer && <React.Fragment>
            {!error && <React.Fragment>
                <Header context={proxy} />
                <LastTrade context={proxy} />
                <Filter context={proxy} />
                {showDataAs==='summary-table' && <SummaryTable context={proxy} />}
                {showDataAs==='price-history' && <PriceHistory context={proxy} />}
                {showDataAs==='yield-history' && <YieldHistory context={proxy} />}
            </React.Fragment>}
            {error===Errors.NO_CUSIP && <ErrorMessage error={error} />}
            {error===Errors.NO_LAST_TRADE && <React.Fragment>
                <Header context={proxy} />
                <ErrorMessage error={error} />
                </React.Fragment>}
            {error===Errors.NO_TRADE_DATA && <React.Fragment>
                <Header context={proxy} />
                <LastTrade context={proxy} />
                <Filter context={proxy} />
                <ErrorMessage error={error} subError={"Please select another date range."} />
                </React.Fragment>}
            </React.Fragment>}
            </div>
        </Loading>
        </div>

    </div></div>

    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/trade-history/main.js